import { CodeResponse, useGoogleLogin } from '@react-oauth/google';
import React from 'react';
import GoogleRenderButton from './GoogleRenderButton';

export interface IGoogleLoginSuccess extends Omit<CodeResponse, 'error' | 'error_description' | 'error_uri'> {}
export interface IGoogleLoginError extends Pick<CodeResponse, 'error' | 'error_description' | 'error_uri'> {}

export interface IGoogleSignInButtonProps {
    onGoogleSignInSuccess : (response : IGoogleLoginSuccess) => Promise<void>;
    onGoogleSignInFailure : (response : IGoogleLoginError) => void;
    buttonText ?: string;
    className ?: string;
}

const GoogleSignInButton = (props : IGoogleSignInButtonProps) : React.ReactElement => {

    const login = useGoogleLogin({
        onSuccess: props.onGoogleSignInSuccess,
        onError: props.onGoogleSignInFailure,
        flow: 'auth-code',
        scope: 'profile email openid',
    });

    const onLoginClick = () : void => {
        login();
    };

    return (
        <GoogleRenderButton
            onClick={onLoginClick}
            text={props.buttonText}
            className={props.className}
        />
    );
};

export default GoogleSignInButton;
